<template>
  <FITFormCard>
    <div slot='header'>
      <h4>{{this.label}}</h4>
    </div>
    <div slot="formBody">
  <CURDModal ref="CURDModals"></CURDModal> 
       <!--      <div class="row mx-0 py-2">
        <b-col cols="3">
          <div class="form-group">
            <FITTextInput v-model="$v.contents.searchInput.value.$model" v-bind="contents.searchInput" @input="setSearch(contents.searchInput.value)"></FITTextInput>
          </div>
        </b-col>
        <b-col cols="auto" class="ml-auto">
          <b-row class="mx-0">
            <FITSelect class="pr-4" v-model="contents.rowsPerPage.value" v-bind="contents.rowsPerPage" @input="setPerPage(contents.rowsPerPage.value)"></FITSelect>
            <FITPagination v-model="contents.pagination.currentPage" :perPage="perPage" :totalRows="total" @input="setCurrentPage(contents.pagination.currentPage)"></FITPagination>
          </b-row>
        </b-col>
      </div>
      <div class="row mx-0 py-2">
        <b-table striped hover responsive :items='dataList' :fields="fields">
          <div slot="fileSize" slot-scope='row'>
            {{ fileSizeFilter(row.value) }}
          </div>
          <div slot="linkedEntity" slot-scope="row">
            {{getTranslation('linkedEntity',row.value)}}
          </div>
          <div slot="publicDocument" slot-scope="row">
            {{getTranslation('publicDocument',row.value)}}
          </div>
          <div slot="documentType" slot-scope="row">
            {{getTranslation('documentType',row.value)}}
          </div>
          <div slot="actions" slot-scope="row">
            <FITDropdown @clicked="documentAction(row.item.ID,$event)" variant="primary" :text="contents.actions.label" :options="contents.actions.options"></FITDropdown>
          </div>
        </b-table>
      </div> -->
      <!-- Container Footer -->
      <!--       <div class="row mx-0 py-2">
        <b-col cols="auto" class="mr-auto align-self-center">
          <h5 class="d-block my-1">{{contents.totalItems.preFix}}: {{total}} {{contents.totalItems.postFix}}</h5>
        </b-col>
        <b-col cols="auto">
          <FITPagination v-model="contents.pagination.currentPage" :perPage="perPage" :totalRows="total" @input="setCurrentPage(contents.pagination.currentPage)"></FITPagination>
        </b-col>
      </div> -->
      <FITSearchableTable :filters="filters" :actions="actions" :columns="columns" searchAction="getDocumentList" vuexModule="Adm" type="document"></FITSearchableTable>
    </div>
  </FITFormCard>
</template>
<script type="text/javascript">
  /* eslint-disable */
  import Vue from 'vue'
  import { FITCheckbox, FITTextInput, FITCheckboxGroup, FITRadio, FITTextarea, FITSelect, FITDatePicker, FITTimepicker, FITvSelect } from '@/components'
  import { FITButton, FITDropdown, FITPagination, FITFormGroup, FITTable, FITFormCard, FITSearchableTable } from '@/components'
  import { required, minLength, between } from 'vuelidate/lib/validators'
  import CURDModal from '@/Adm/EntityManagement/components/CURDModal.vue'
  import { API, APIList } from '@/api'
  import { mapGetters } from 'vuex'



  var searchThread;
  export default {
    name: 'Document',
    components: {
      FITButton,
      FITDropdown,
      FITTextInput,
      FITSelect,
      FITPagination,
      FITFormGroup,
      FITTable,
      FITFormCard,
      FITButton,
      CURDModal,
      FITSearchableTable
    },
    props: {

    },
    data() {
      return {
        api: new APIList(),
        label: this.$t('adm.document.listTitle'),
        contents: {
          searchInput: { value: this.$store.state.EntityManagement.dataList.search, placeholder: this.$t("adm.contents.EntityManagement.search") },
          rowsPerPage: { value: this.$store.state.EntityManagement.dataList.perPage, options: this.$store.state.EntityManagement.dataList.perPageOptions, label: this.$t("adm.contents.EntityManagement.perPage") },
          pagination: { currentPage: this.$store.state.EntityManagement.dataList.currentPage },
          totalItems: { preFix: this.$t("adm.contents.EntityManagement.total"), postFix: this.$t("adm.contents.EntityManagement.records") },
          actions: {
            value: { rowID: '', action: '' },
            key: 'actions',
            label: 'Actions',
            options: [{key: 'download',text: this.$t('adm.document.download')},
            { key: 'delete',text: this.$t('adm.document.remove')},
          ]
        }
      },


// FITSearchableTable
      filters: [{
          label: this.$t('adm.document.fields.linkedEntity'),
          key: 'linkedEntity',
          type: 'select',
          default: null, // Default All
        },
      ],
      actions: [
      { key: 'download', 
      text: this.$t('adm.document.download'),
      callback: (key, row, instance) => {
        let ID = parseInt(row.ID);
        this.api.fileDownload(ID);
      } 
      },
      ],
      columns: [
      { key: 'ID', label: this.$t('adm.document.fields.ID'),sortable: true },
      { key: 'documentName', label: this.$t('adm.document.fields.documentName'),sortable: true },
      { key: 'linkedEntity', label: this.$t('adm.document.fields.linkedEntity'),sortable: true , formatter: (row, key, item) => {
          return this.getTranslated(key, row);
        } },
        // { key: 'fileSize', label: this.$t('adm.document.fields.fileSize') },
        { key: 'documentType', label: this.$t('adm.document.fields.documentType'),sortable: true, formatter: (row, key, item) => {
          return this.getTranslated(key, row);
        } },
        { key: 'publicDocument', label: this.$t('adm.document.fields.publicDocument'),sortable: true , formatter: (row, key, item) => {
          return this.getTranslated(key, row);
        }},
        { key: 'documentTag', label: this.$t('adm.document.fields.documentTag') },
        { key: 'remarks', label: this.$t('adm.document.fields.remarks') },
        { key: 'createTime', label: this.$t('adm.document.fields.createTime'),sortable: true },
        // { key: 'createUser', label:this.$t('adm.document.fields.createUser'), 'class': 'text-left' },
        ],
      }
    },

    created() {
    // this.initialization();
  },
  computed: { // Get Realtime Vuex Value
    // ...mapGetters('Adm', ['getTranslated']),
    // linkedEntity() {
    //   let result = this.getTranslated(this.$i18n.locale, 'linkedEntity');
    //   result.unshift({ text: 'All', value: null });
    //   return result;
    // },
    // documentType() {
    //   let result = this.getTranslated(this.$i18n.locale, 'documentType');
    //   result.unshift({ text: 'All', value: null });
    //   return result;
    // },
    // slots() {
    //   let slots = ['fileSize', 'remove'];
    //   return slots;
    // },
    // fields() {
    //   return this.$store.state.EntityManagement.dataList.fields;
    // },
    // search() {
    //   return this.$store.state.EntityManagement.dataList.search;
    // },

    // perPage() {
    //   return this.$store.state.EntityManagement.dataList.perPage;
    // },

    // currentPage() {
    //   return this.$store.state.EntityManagement.dataList.currentPage;
    // },

    // total() {
    //   return this.$store.state.EntityManagement.dataList.total;
    // },
    // dataList() {
    //   return this.$store.state.EntityManagement.dataList.list;
    // }

    ...mapGetters(['getTranslatedArray'])


  },
  // validations: {
  //   contents: {
  //     searchInput: {
  //       value: {
  //         required,
  //         minLength: minLength(5)
  //       }
  //     }
  //   },
  // },
  mounted() {

  },
  methods: {
    // initialization() {
    //   this.$store.commit({ type: 'EntityManagement/setCategory', category: 'DM' });
    //   this.$store.commit({ type: 'EntityManagement/setIdentity', identity: 'document' });
    //   this.$store.commit({ type: 'EntityManagement/setEntity', entity: 'dm_document' });


    //   // List Fields Definition
    //   let fields = [
    //     { key: 'ID', label: this.$t('adm.document.fields.ID') },
    //     { key: 'documentName', label: this.$t('adm.document.fields.documentName') },
    //     { key: 'linkedEntity', label: this.$t('adm.document.fields.linkedEntity'), 'class': 'text-left' },
    //     // { key: 'fileSize', label: this.$t('adm.document.fields.fileSize') },
    //     { key: 'documentType', label: this.$t('adm.document.fields.documentType'), 'class': 'text-left' },
    //     { key: 'publicDocument', label: this.$t('adm.document.fields.publicDocument'), 'class': 'text-left' },
    //     { key: 'documentTag', label: this.$t('adm.document.fields.documentTag'), 'class': 'text-left' },
    //     { key: 'remarks', label: this.$t('adm.document.fields.remarks'), 'class': 'text-left' },
    //     { key: 'createTime', label: this.$t('adm.document.fields.createTime') },
    //     // { key: 'createUser', label:this.$t('adm.document.fields.createUser'), 'class': 'text-left' },
    //     { key: 'actions', label: this.$t('adm.document.fields.actions'), 'class': 'text-left' },

    //   ];
    //   this.$store.commit({ type: 'EntityManagement/setDataFields', fields: fields });

    //   // getAllSelection
    //   this.$store.dispatch('getAllSelections', 'document')
    //     .then((json) => {
    //       this.$store.commit({ type: 'Adm/setSelections', selections: json.data });
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });

    //   // Set Initial Current Page and get Data List
    //   this.setCurrentPage(1);

    // },

    // status(validation) {
    //   return {
    //     error: validation.$error,
    //     dirty: validation.$dirty
    //   }
    // },
    // setSearch(input) {
    //   // console.log(input);
    //   var vm = this;
    //   clearTimeout(searchThread);
    //   searchThread = setTimeout(function() {
    //     vm.$store.commit({ type: 'EntityManagement/setSearch', search: input });
    //     vm.getDataList();
    //   }, 1000);
    // },
    // setPerPage(amount) {
    //   // console.log(amount);
    //   this.contents.rowsPerPage.value = amount;
    //   this.$store.commit({ type: 'EntityManagement/setPerPage', perPage: amount });
    //   this.contents.pagination.currentPage = 1;
    //   this.$store.commit({ type: 'EntityManagement/setCurrentPage', currentPage: 1 });
    //   this.getDataList();
    // },
    // setCurrentPage(currentPage) {
    //   // console.log(currentPage);
    //   this.contents.pagination.currentPage = currentPage;
    //   this.$store.commit({ type: 'EntityManagement/setCurrentPage', currentPage: currentPage });
    //   this.getDataList();
    // },
    // getDataList() {
    //   // this.$store.dispatch('EntityManagement/getDataList');
    //   this.$store.dispatch('EntityManagement/getDocumentDataList');
    // },
    // clickedRowID(value) {
    //   this.contents.actions.value.rowID = value.ID;
    //   var object = {
    //     rowID: this.contents.actions.value.rowID,
    //     action: this.contents.actions.value.action
    //   }
    //   this.showModal(object);
    // },
    // showModal(object) {
    //   // console.log(object);
    //   this.$refs.CURDModals.openCURDModal(object);
    // },
    // fileSizeFilter(fileSizeInBytes) {
    //   if (fileSizeInBytes) {
    //     var i = -1;
    //     var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    //     do {
    //       fileSizeInBytes = fileSizeInBytes / 1024;
    //       i++;
    //     } while (fileSizeInBytes > 1024);

    //     return Math.max(fileSizeInBytes, 0.1).toFixed(2) + byteUnits[i];
    //   } else {
    //     return '0';
    //   }
    // },
    // documentAction(ID, action) {
    //   switch (action) {
    //     case 'delete':
    //       this.showModal({ rowID: ID, action: action });
    //       break;
    //     case 'download':
    //       this.api.fileDownload(ID);
    //       break;
    //   }
    // },
    // getTranslation(type, value) {
    //   let translatedString = '';
    //   switch (type) {
    //     case 'publicDocument':
    //       if (value == 'Y') {
    //         translatedString = 'Yes';
    //       } else {
    //         translatedString = 'No';
    //       }
    //       break;
    //     case 'linkedEntity':
    //     case 'documentType':
    //       for (var i = this[type].length - 1; i >= 0; i--) {
    //         if (this[type][i].value == value) {
    //           translatedString = this[type][i].text;
    //         }
    //       }
    //       break;
    //   }
    //   return translatedString;
    // },

    onRowClicked(row) {
      console.debug(row)
    },
    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      if (type == "publicDocument") {
        if (key == "Y") { return "Yes"; } else { return "No"; }
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Adm', type)
      .filter((item) => {
        return item.value === key
      });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    }
  }
}

</script>
<style type="text/css">
.ContainerTemplate {
  padding: 1rem 3rem;
  width: 100%;
  background-color: white;
}

.ContainerTemplate h4 {
  color: #555555;
}

</style>



// WEBPACK FOOTER //
// src/Adm/EntityManagementDM/containers/Document.vue